import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/home.vue'
import Cooperation from '@/pages/cooperation.vue'
import Help from '@/pages/help.vue'

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)
  
export default new Router({
    mode: 'hash',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/home',
            name: 'home',
            component: Home
        },
        {
            path: '/cooperation',
            name: 'cooperation',
            component: Cooperation
        },
        {
            path: '/API',
            name: 'API',
            component: () => import('@/pages/API'),
            meta: {
              title: 'API文档',
            }
        },
        {
            path: '/Help',
            name: 'Help',
            component: Help
        }
    ]
})